/* eslint-disable */
import { ASSISTED_USERS_MYSELF } from '@ringcentral-integration/commons/modules/RcVideo';
export default {
  topic: 'Meeting title',
  date: 'Date',
  startTime: 'Time',
  duration: 'Duration',
  scheduleFor: 'Schedule on behalf of',
  meetingSettings: 'Meeting settings',
  meetingSettingsDescription:
    'Updates to these settings will apply to the current meeting only.',
  here: 'here',
  [ASSISTED_USERS_MYSELF]: 'Myself',
  joinBeforeHost: 'Allow participants to join before host',
  enableWaitingRoom: 'Enable waiting room',
  waitingRoom: 'Enable waiting room for',
  waitingRoomTitle: 'Waiting room',
  waitingRoomDescription: 'Keep meetings private until you admit participants.',
  waitingRoomNotCoworker: 'Anyone outside my company',
  waitingRoomGuest: 'Anyone not signed in',
  waitingRoomAll: 'Everyone',
  enterPassword: 'Enter Password',
  onlyJoinAfterMe: 'Participants can only join after me',
  onlyJoinAfterHost: 'Participants can only join after host',
  allowJoinBeforeHostDescription:
    'Keeps the meeting secure and distraction-free until you join.',
  muteAudio: 'Mute audio for participants',
  turnOffCamera: 'Turn off camera for participants',
  requirePassword: 'Require password',
  useE2ee: 'Use end-to-end encryption',
  e2eeTooltip:
    'End-to-end encrypted meetings are the most private, but features like joining by phone, closed captions and recording aren’t available.',
  setPassword: 'Set password *',
  setPasswordNotSymbol: 'Set password',
  passwordEmptyError: 'Meeting password required',
  passwordInvalidError:
    'Your password must be 1–10 letters and numbers long but cannot contain symbols',
  passwordHintText:
    'Your password should be 1–10 letters and numbers long but cannot contain symbols',
  usePersonalMeetingId: 'Use Personal Meeting ID',
  usePersonalMeetingIdInstead: 'Use personal meeting instead',
  usePersonalMeetingName: 'Use personal meeting:',
  meetingSettingsSecurity: 'Security',
  onlyAuthUserJoin: 'Only authenticated users can join',
  signedInUsers: 'Signed-in users',
  signedInCoWorkers: 'Signed-in colleagues',
  limitScreenSharing: 'Only the host & moderators can share screen',
  lockTooltip: 'This setting is managed by your company admin',
  pmiSettingAlert: 'These settings will apply to all meetings created with PMI',
  today: 'Today',
  scheduleForGuidance:
    'Scheduling for someone else?\n1. Make sure you’re on their Outlook calendar.\n2. From the dropdown, select the person you’re scheduling for.\n',
  scheduleForGuidanceMore: 'Learn details',
  changePmiSettings: 'Change Personal Meeting settings',
  allowToRecording: 'Allow to start and stop recording',
  allowTranscribe: 'Allow to start and stop transcription',
  everyone: 'Everyone',
  onlyHostModerators: 'Only host and moderators',
  advancedSettings: 'Advanced settings',
  whoCanJoin: 'Who can join?',
  requirePasswordDescription:
    'Participants who join via the meeting link won’t need to enter the password.',
  password: 'Password:',
  passwordLabel: 'Password',
  edit: 'Edit',
  changePassword: 'Change password',
  passwordRequired: 'Password is required',
  passwordLengthError: 'Password must be 1–10 characters long',
  passwordFormatError: 'Password can only contain letters and numbers',
  passwordHint:
    'Your password should be 1–10 letters and numbers long, but cannot contain symbols.',
} as const;

// @key: @#@"topic"@#@ @source: @#@"Meeting title"@#@
// @key: @#@"date"@#@ @source: @#@"Date"@#@
// @key: @#@"startTime"@#@ @source: @#@"Time"@#@
// @key: @#@"duration"@#@ @source: @#@"Duration"@#@
// @key: @#@"scheduleFor"@#@ @source: @#@"Schedule on behalf of"@#@
// @key: @#@"meetingSettings"@#@ @source: @#@"Meeting settings"@#@
// @key: @#@"meetingSettingsDescription"@#@ @source: @#@"Update these settings will apply to current meeting only."@#@
// @key: @#@"here"@#@ @source: @#@"here"@#@
// @key: @#@"ASSISTED_USERS_MYSELF"@#@ @source: @#@"Myself"@#@
// @key: @#@"joinBeforeHost"@#@ @source: @#@"Allow participants to join before host"@#@
// @key: @#@"enableWaitingRoom"@#@ @source: @#@"Enable waiting room"@#@
// @key: @#@"waitingRoom"@#@ @source: @#@"Enable waiting room for"@#@
// @key: @#@"waitingRoomTitle"@#@ @source: @#@"Waiting room"@#@
// @key: @#@"waitingRoomDescription"@#@ @source: @#@"Keep meetings private until you admit participants."@#@
// @key: @#@"waitingRoomNotCoworker"@#@ @source: @#@"Anyone outside my company"@#@
// @key: @#@"waitingRoomGuest"@#@ @source: @#@"Anyone not signed in"@#@
// @key: @#@"waitingRoomAll"@#@ @source: @#@"Everyone"@#@
// @key: @#@"enterPassword"@#@ @source: @#@"Enter Password"@#@
// @key: @#@"onlyJoinAfterMe"@#@ @source: @#@"Participants can only join after me"@#@
// @key: @#@"onlyJoinAfterHost"@#@ @source: @#@"Participants can only join after host"@#@
// @key: @#@"allowJoinBeforeHostDescription"@#@ @source: @#@"Keeps the meeting secure and distraction-free until you join."@#@
// @key: @#@"muteAudio"@#@ @source: @#@"Mute audio for participants"@#@
// @key: @#@"turnOffCamera"@#@ @source: @#@"Turn off camera for participants"@#@
// @key: @#@"requirePassword"@#@ @source: @#@"Require password"@#@
// @key: @#@"useE2ee"@#@ @source: @#@"Use end-to-end encryption"@#@
// @key: @#@"e2eeTooltip"@#@ @source: @#@"End-to-end encrypted meetings are the most private, but features like joining by phone, closed captions, and recording aren't available."@#@
// @key: @#@"setPassword"@#@ @source: @#@"Set password *"@#@
// @key: @#@"setPasswordNotSymbol"@#@ @source: @#@"Set password"@#@
// @key: @#@"passwordEmptyError"@#@ @source: @#@"Meeting password required"@#@
// @key: @#@"passwordInvalidError"@#@ @source: @#@"Your password must be 1-10 letters and numbers long but cannot contain symbols"@#@
// @key: @#@"passwordHintText"@#@ @source: @#@"Your password should be 1-10 letters and numbers long but cannot contain symbols"@#@
// @key: @#@"usePersonalMeetingId"@#@ @source: @#@"Use Personal Meeting ID"@#@
// @key: @#@"usePersonalMeetingIdInstead"@#@ @source: @#@"Use personal meeting instead"@#@
// @key: @#@"usePersonalMeetingName"@#@ @source: @#@"Use personal meeting:"@#@
// @key: @#@"meetingSettingsSecurity"@#@ @source: @#@"Security"@#@
// @key: @#@"onlyAuthUserJoin"@#@ @source: @#@"Only authenticated users can join"@#@
// @key: @#@"signedInUsers"@#@ @source: @#@"Signed in users"@#@
// @key: @#@"signedInCoWorkers"@#@ @source: @#@"Signed in co-workers"@#@
// @key: @#@"limitScreenSharing"@#@ @source: @#@"Only host & moderators can share screen"@#@
// @key: @#@"lockTooltip"@#@ @source: @#@"This setting is managed by your company admin"@#@
// @key: @#@"pmiSettingAlert"@#@ @source: @#@"These settings will apply to all meetings created with PMI"@#@
// @key: @#@"today"@#@ @source: @#@"Today"@#@
// @key: @#@"scheduleForGuidance"@#@ @source: @#@"Scheduling for someone else?\n1. Make sure you're on their Outlook calendar.\n2. From the dropdown, select the person you're scheduling for.\n"@#@
// @key: @#@"scheduleForGuidanceMore"@#@ @source: @#@"Learn details"@#@
// @key: @#@"changePmiSettings"@#@ @source: @#@"Change Personal Meeting settings"@#@
// @key: @#@"allowToRecording"@#@ @source: @#@"Allow to start and stop recording"@#@
// @key: @#@"allowTranscribe"@#@ @source: @#@"Allow to start and stop transcription"@#@
// @key: @#@"everyone"@#@ @source: @#@"Everyone"@#@
// @key: @#@"onlyHostModerators"@#@ @source: @#@"Only host and moderators"@#@
// @key: @#@"advancedSettings"@#@ @source: @#@"Advanced settings"@#@
// @key: @#@"whoCanJoin"@#@ @source: @#@"Who can join?"@#@
// @key: @#@"requirePasswordDescription"@#@ @source: @#@"Participants who join via the meeting link won’t need to enter the password."@#@
// @key: @#@"password"@#@ @source: @#@"Password:"@#@
// @key: @#@"passwordLabel"@#@ @source: @#@"Password"@#@
// @key: @#@"edit"@#@ @source: @#@"Edit"@#@
// @key: @#@"changePassword"@#@ @source: @#@"Change Password"@#@
// @key: @#@"passwordRequired"@#@ @source: @#@"Password is required"@#@
// @key: @#@"passwordLengthError"@#@ @source: @#@"Password must be 1-10 characters long"@#@
// @key: @#@"passwordFormatError"@#@ @source: @#@"Password can only contain letters and numbers"@#@
// @key: @#@"passwordHint"@#@ @source: @#@"Your password should be 1-10 letters and numbers long, but can not contain symbols."@#@
